import PropTypes from 'prop-types';

export const DataLoginProps = {
    isLogin:                PropTypes.bool,
    legalIssuesModalOpen:   PropTypes.bool,
    modalOpen:              PropTypes.bool,
    propModalOpne:          PropTypes.bool
}